module.exports = __webpack_public_path__ + "static/img/cd_yd_disabled.c2abd60f.png";